export const DISPLAY_MODE_FULL = "full";

export const COURSE_TYPE_ONLINE = "Online";
export const COURSE_TYPE_CLASSROOM = "Classroom";
export const COURSE_TYPE_ACTIVITY = "Activity";

export const COLOR_PROGRESS = "rgba(45, 85, 40, 0.8)";

export const PROGRESS_ALL = "ALL";
export const FILTER_TODO = "lefttodo";
export const FILTER_DONE = "completed";
export const FILTER_ONGOING = "begun";
export const MODE_FULL = "full";
export const MODE_SIMPLE = "simple";
export const NOOFCOURSES = 5;
